import React, { useCallback, useContext } from "react";
import Drawer from "@material-ui/core/Drawer";

import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import PickerHeader from "bodycodi/cmap/app/components/common/pickerHeader";

type MemoEditPopProp = {
  title: string;
  placeHolder: string;
  memoContent: string;
  memoReadOnly: string;
  onEdit: () => void;
  onChange: (value: string) => void;
};

const MemoEditPop = ({
  title,
  placeHolder,
  memoContent,
  memoReadOnly,
  onEdit,
  onChange,
}: MemoEditPopProp) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  const handleClose = useCallback(() => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CHOOSE_SCHEDULE_TYPE",
      open: { memoEditPop: false },
    });
    onChange(memoReadOnly);
  }, [memoReadOnly]);

  return (
    <Drawer
      anchor="bottom"
      open={state.memoEditPop}
      onClose={handleClose}
      className="picker-pop auto"
    >
      <PickerHeader title={title} onClose={handleClose} />
      <div className="picker-body">
        <div className="schedule-memo-pop">
          <div className="memo-card">
            <textarea
              placeholder={placeHolder}
              maxLength={1000}
              value={memoContent}
              onChange={(e) => onChange(e.target.value)}
            />
          </div>
        </div>
        <div className="add-schedule-center-confirm no-shadow">
          <div className="btn-group no-border">
            <div className="btn left white" onClick={handleClose}>
              취소
            </div>
            <div
              className={`btn right ${memoContent === memoReadOnly ? "gray" : "blue"}`}
              onClick={memoContent === memoReadOnly ? () => ({}) : onEdit}
            >
              저장
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default MemoEditPop;
